import PropTypes from "prop-types";
import React, { ReactNode } from "react";

import css from "./badge_icon.module.scss";

interface IProps {
  value?: number;
  icon: ReactNode;
}

const BadgeIcon = ({ icon, value }: IProps) => (
  <div className={css.root}>
    {icon}
    {!!value && (
      <div className={css.valueContainer}>
        <div className={css.value}>{value <= 9 ? value : "9+"}</div>
      </div>
    )}
  </div>
);

BadgeIcon.propTypes = {
  icon: PropTypes.node,
  value: PropTypes.number
};

export default BadgeIcon;
